(function (window, document, undefined) {
  ("use strict");

  let Vue = window.Vue || false,
    logger;

  /**
   * Initialize.
   * Check if Vue is available, get the widget DOM element by id and start rendering.
   *
   * @return {undefined}
   */
  const init = () => {
    try {
      logger = new window.RussMedia.Utils.Logger("[livecams] ");
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    }

    const livecamWidgetWrapper = document.getElementById("vodl-livecams-wrapper");

    if (!livecamWidgetWrapper) {
      logger.log("_init: No livecam widget!");
      return;
    }

    Vue.createApp({
      components: {
        LivecamsWidget: window["@russmedia-frontend/np-widgets"].LivecamsWidget,
      }
    }).mount("#vodl-livecams-wrapper");
  };

  init();

})(window, document);